"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.cloneObject = cloneObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description Clones the given Object.
 * @summary
 * NOTE: Because of the limitations of this method, only primitive types are clonable.
 *
 * @example
 * import { cloneObject } from '@nimius/object-utility'
 *
 * const first = { a: 'test' }
 * const second =  cloneObject(first)
 * first.a = 'hello'
 *
 * console.log(first.a)
 * // => hello
 * console.log(second.a)
 * // => test
 *
 * @template T - Type of the object that is cloned.
 * @param {T} object - The Object that should be cloned. This can be any deep
 *        structure of primitive types.
 * @returns {T} Clone of the Object given to the method.
 */
function cloneObject(object) {
  return JSON.parse((0, _stringify2.default)(object));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/object-utility/src/clone-object.js
// module id = 68
// module chunks = 0 2